import { render, staticRenderFns } from "./payConfig.vue?vue&type=template&id=1830399e&"
import script from "./payConfig.vue?vue&type=script&lang=js&"
export * from "./payConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports